
import { useAtom } from "jotai";
import React, { useRef } from "react";
import Rocket from "../meshes/Rocket.jsx";
import Ufo from "../meshes/Ufo.jsx";
import { selectionAtom, tilesAtom } from "../GlobalState.jsx";
import { tileType } from "../gameLogic/rules.js";
import { animated } from "@react-spring/three";
import { useAnimationPlaying } from "../hooks/useAnimationPlaying.jsx";
import useSelect from "../hooks/useSelect";
import { trackEvent } from '../api';

export default function Piece ({
  position=[0,0,0],
  rotation=[0,0,0],
  tile,
  team,
  id,
  scale=1,
  selectable=false,
  selected=false,
  onBoard=false,
}) {
  const [selection] = useAtom(selectionAtom);
  const [tiles] = useAtom(tilesAtom)
  const animationPlaying = useAnimationPlaying()

  const group = useRef();
  const wrapperMat = useRef();
  const wrapper = useRef();

  function handlePointerEnter(event) {
    event.stopPropagation();
    // wrapperMat.current.opacity += 0.2;
    document.body.style.cursor = "pointer";
  }

  function handlePointerLeave(event) {
    event.stopPropagation();
    // wrapperMat.current.opacity -= 0.2;
    document.body.style.cursor = "default";
  }

  const handlePointerDown = useSelect({
    targetTile: tile,
    canStartSelection: ({ client }) => client.team === team,
    getSelectionData: () => {
      if (tileType(tile) === "home") {
        const history = [];
        return {
          tile,
          pieces: [{ tile, team, id, history }],
          history,
          team,
        };
      }

      const pieces = tiles[tile];
      return {
        tile,
        pieces,
        history: pieces[0].history,
        team,
      };
    },
    isLegalMoveTarget: ({ targetTile, legalTiles }) => targetTile in legalTiles,
  });

  return (
    <animated.group
      position={position}
      rotation={rotation}
      ref={group}
      scale={scale}
    >
      <mesh
        castShadow
        rotation={[-Math.PI / 4, 0, 0]}
        onPointerDown={(event) => {
          handlePointerDown(event)
        }}
        onPointerOver={(event) => handlePointerEnter(event)}
        onPointerLeave={(event) => handlePointerLeave(event)}
        ref={wrapper}
      >
        <sphereGeometry args={[0.55, 32, 16]} />
        <meshBasicMaterial
          transparent
          opacity={0}
          ref={wrapperMat}
          depthWrite={false}
        />
      </mesh>
      { team === 0 ? <Rocket 
      animationPlaying={animationPlaying}
      selected={selected}
      onBoard={onBoard}
      selectable={selectable}
      selection={selection}/> : <Ufo 
      animationPlaying={animationPlaying}
      selected={selected}
      onBoard={onBoard}
      selectable={selectable}
      selection={selection}/>}
    </animated.group>
  )      
};